import React from 'react';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen bg-gradient-to-b from-sky-50 via-indigo-50 to-white px-6 pt-32 pb-20 lg:px-8">
      <Helmet>
        <title>Integritetspolicy | Nordic Route</title>
        <meta
          name="description"
          content="Integritetspolicy för Nordic Route Scandinavia AB."
        />
      </Helmet>

      <div className="mx-auto max-w-3xl">
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-lg sm:p-10">
          
          <div className="mb-10 border-b border-slate-200 pb-6">
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Integritetspolicy
            </h1>
            <p className="mt-3 text-sm text-slate-500">
              Information om hur Nordic Route hanterar personuppgifter.
            </p>
          </div>

          <div className="space-y-8 text-sm leading-7 text-slate-600">
            
            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Personuppgiftsansvarig
              </h2>
              <p>
                Nordic Route Scandinavia AB, org.nr 559538-0766.
                <br />
                E-post:{' '}
                <a
                  href="mailto:nordicroutestransport@gmail.coms"
                  className="text-indigo-600 underline-offset-4 hover:underline"
                >
                  nordicroutestransport@gmail.com
                </a>
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Vilka uppgifter samlar vi in?
              </h2>
              <p>
                När du använder vårt kontaktformulär kan vi samla in ditt namn,
                e-postadress, telefonnummer, meddelande och vald tjänst.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Varför samlar vi in uppgifterna?
              </h2>
              <p>
                Uppgifterna används för att kunna hantera din förfrågan och
                kontakta dig angående den tjänst du valt.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Formspree
              </h2>
              <p>
                Kontaktformuläret hanteras via Formspree. Uppgifterna skickas
                genom Formspree till Nordic Route Scandinavia AB för att vi ska
                kunna hantera din förfrågan.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Lagring
              </h2>
              <p>
                Vi sparar inte uppgifterna längre än vad som är nödvändigt för
                att hantera din förfrågan.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">
                Kontakt
              </h2>
              <p>
                Om du har frågor om denna integritetspolicy kan du kontakta oss
                på{' '}
                <a
                  href="mailto:nordicroutestransport@gmail.coms"
                  className="text-indigo-600 underline-offset-4 hover:underline"
                >
                  nordicroutestransport@gmail.com
                </a>
                .
              </p>
            </section>

          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;